import axios from 'axios'
export default {
  computed: {
    prepareCheckoutUrl() {
      if (this.isFlightCalculation){
        return `${process.env.BASE_URL}/api/booking/${this.productId}/flight_prepare_checkout`
      }else{
        return `${process.env.BASE_URL}/api/booking/${this.productId}/hotel_only_prepare_checkout`
      }
    }
  },
  methods: {
    sendBookingProceed(){
      var params = {
        flight_proposal_id: this.flightProposalId,
        product_base_id:  this.productId,
        calculation_data: JSON.stringify(this.result.calculation_data),
        insurance: this.selectedInsurance
      }
     this.$emit('next-started')
     axios.post(this.prepareCheckoutUrl, params )
     .then(response => {
       this.$emit('next-loaded', response.data)
     })
    },
  }
}